import React from 'react';
/*
To import child routes, insert the following code:
import { <childComponent>Routes } from './components/<child-folder>';
*/

import { Route } from '@plasma/ui.application.router';

const UsersPage = React.lazy(() => import('.'));

export const usersPageRoutes = [
  new Route({
    path: '/users-page',
    element: UsersPage,
    children: [],
  }),
];
